import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React from "react";
import { texts } from "../../../../general/texts";

const SelectCity = ({ state, handleTextFieldChange, ukSubUtilities }) => {
  return (
    <Grid container item md={12} justifyContent="flex-start">
      <Box sx={{ width: "100%" }}>
        <FormControl fullWidth size="small" color="warning">
          <InputLabel id="demo-simple-select-label">{texts["dialog-city"]}</InputLabel> 
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={state.service}
            label="Qyteti"
            onChange={handleTextFieldChange("service")}
            MenuProps={{ sx: { height: "700px" } }}
          >
            <ListSubheader>
              <TextField
                size="small"
                // Autofocus on textfield
                autoFocus
                color={"warning"}
                label={texts["placeholder-search-city"]}
                fullWidth
                value={state.search}
                onChange={handleTextFieldChange("search")}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    // Prevents autoselecting item while typing (default Select behaviour)
                    e.stopPropagation();
                  }
                }}
              />
            </ListSubheader>
            {ukSubUtilities
              .filter((ukSubUtilities) =>
                ukSubUtilities.publicName
                  .toLowerCase()
                  .startsWith(state.search.toLowerCase())
              )
              .map((option) => (
                <MenuItem key={option.serviceName} value={option.serviceName}>
                  {option.publicName}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>
    </Grid>
  );
};

export default SelectCity;

{
  /* <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={ukSubUtilities}
            getOptionLabel={(option) => option.publicName}
            onChange={(event, newValue) => {
              setState({...state, service: newValue.serviceName})
            }}
            sx={{ width: '100%' }}
            renderInput={(params) => <TextField {...params} placeholder="Qyteti" size="small" color="warning"/>}
        /> */
}
{
  /* <TextField
            select
            label="Qyteti"
            value={state.service}
            onChange={handleTextFieldChange("service")}
            color="warning"
            size="small"
            className={classes.textField}
          >
            {ukSubUtilities.map((option) => (
              <MenuItem key={option.serviceName} value={option.serviceName}>
                {option.publicName}
              </MenuItem>
            ))}
          </TextField>*/
}
